// TourLauncher.jsx
import React, { useState, createContext, useContext } from 'react';
import Joyride from 'react-joyride';
import tourSteps from './tourSteps'; // ✅ Import your centralized step config

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [steps, setSteps] = useState([]);
  const [run, setRun] = useState(false);

  return (
    <TourContext.Provider value={{ steps, setSteps, run, setRun }}>
      <>
        {children}
        <Joyride
          steps={steps}
  run={run}
  showSkipButton
  continuous
  scrollToFirstStep
  disableOverlayClose={false}
  spotlightClicks={true} // ✅ optional
  disableScrolling={false}
  styles={{ options: { zIndex: 10000 } }}
  callback={(data) => {
    if (['finished', 'skipped'].includes(data.status)) {
      setRun(false);
    }
  }}
        />
      </>
    </TourContext.Provider>
  );
};

// Custom hook for using the tour anywhere
export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) throw new Error('useTour must be used within TourProvider');
  const { setSteps, setRun } = context;

  const startTour = (section) => {
    if (!tourSteps[section]) {
      console.warn(`No tour steps defined for section: ${section}`);
      return;
    }
    setSteps(tourSteps[section]);
    setRun(true);
  };

  return { startTour };
};

export default TourProvider;
